import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Consultoria",
    component: () => import("@/views/Consultas.vue"),
    children: [
      {
        path: "/listar-consulta/:id",
        name: "Ver consulta",
        component: () => import("@/views/verConsulta.vue"),
      },
    ],
  },
  {
    path: "/consultoria",
    name: "Consultoria ",
    component: () => import("@/views/Consultas.vue"),
    children: [
      {
        path: "/consultoria/listar-consulta/:id",
        name: "Consultoria > Ver consulta",
        component: () => import("@/views/verConsulta.vue"),
      },
    ],
  },
  {
    // path: "/consultoria_novo/app",
    // path: "/consultoria_novo/app_dev",
    path: "/",
    name: "Consultoria  ",
    component: () => import("@/views/Consultas.vue"),
    children: [
      {
        // path: "/consultoria_novo/app/listar-consulta/:id",
        // path: "/consultoria_novo/app_dev/listar-consulta/:id",
        path: "/listar-consulta/:id",
        name: "Consultoria  > Ver consulta",
        component: () => import("@/views/verConsulta.vue"),
      },
    ],
  },

  {
    path: "/about",
    name: "About",
    component: () => import("@/views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  // base: "/consultoria_novo/app/",
  // base: "/consultoria_novo/app_dev/",
  base: "/",
  routes,
});

export default router;
